export default __webpack_public_path__ + "static/media/188.cfa087a9.png";